const Login = () =>{

    return(
        <div className="App">
            <div className='Seccion' id='Login'>
                <h1>Pagina para mostrar Login</h1>
            </div>
        </div>
    );
}
    
    export default Login;